
import axios from 'axios';
import generateVersionHash from '@utils/generateVersionHash';
import state from './state';
import mutations from './mutations';
import { postApi } from '../../../lib/fetcher';
import  api  from './constants';

const historyTransactionFile = {
  namespaced: true,
  state,
  mutations,
  actions: {
    async getData(ctx, { date, page, itemsPerPage, search }) {
      const URL_API = api.GET_LIST_HISTORY_INSERT_FILE_TRANSACTION;
      if (ctx.state.requestData) ctx.state.requestData.cancel();

      const axiosSource = axios.CancelToken.source();
      ctx.commit('setCancelation', {
        cancel: axiosSource.cancel,
        msg: 'Loading...',
      });

      ctx.commit('clearData');
      ctx.commit('setLoading', true);
      
      const version = generateVersionHash(itemsPerPage.toString() + page.toString(), date);

      const data = JSON.stringify({
        page: page.toString(),
        limit: itemsPerPage.toString(),
        search,
        sort_by: 'id DESC',
        version
      });

      const addConfig = { cancelToken: axiosSource.token };

      const responseData = await postApi(ctx, URL_API, data, addConfig);

      if (responseData?.code === 200) {
        ctx.commit('setTotalData', { payload: responseData });
        ctx.commit('setData', { payload: responseData });
      }
    },
    async downloadResult(ctx, { date, id }) {
      ctx.commit('setOnDownloadResult', true);
    
      const version = generateVersionHash(date);
      const data = {
        id,
        version,
      };
    
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}/${api.DOWNLOAD_RESULT_INSERT_FILE_OFF_US}`,
          data,
          {
            headers: {
              'X-CSRF-TOKEN': JSON.parse(localStorage.getItem('logged_in_qram')).token,
              'X-Origin-Path': window.location.pathname
            },
            responseType: 'blob',
          }
        );
    
        const disposition = response.headers['content-disposition'];
        let filename = 'Transaction_File_Off_Us.xlsx';
    
        if (disposition && disposition.includes('filename=')) {
          const [, extractedFilename] = disposition?.match(/filename="?([^"]+)"?/) || [];
          if (extractedFilename) {
            filename = extractedFilename;
          }
          
        }
    
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
    
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
    
        ctx.commit('setOnDownloadResult', false);
      } catch (error) {
        ctx.commit('setOnDownloadResult', false);
        ctx.commit('setSnackbar', {
          status: true,
          message: 'Download failed!',
          icon: 'mdi-alert',
          color: 'red',
        }, { root: true });
      }
    },
    

  },
};

export default historyTransactionFile;
